// lib
import { Modifier, EditorState, SelectionState } from 'draft-js'
import { removeSelectedContentFromEditorState } from '@aytm/lib/rfd-ui/components/advanced/lib/draft-js/editor-tools'

export default function createCharLimitPlugin(config = {}) {
  const { limit = 0, trim = true, countText = (text = '') => text.trim().replace(/\n/g, '').length } = config

  const countTextAfterInsertion = function (text = '', editorState) {
    const editorStateText =
      removeSelectedContentFromEditorState(editorState).getCurrentContent().getPlainText('\n') || ''
    return countText(trim ? (editorStateText + (text || '')).trim() : editorStateText + (text || ''))
  }

  return {
    handleBeforeInput(chars = '', editorState) {
      if (limit > 0) {
        if (countTextAfterInsertion(chars, editorState) > limit) {
          return 'handled'
        }
      } else if (0 === limit) {
        return 'handled'
      }
      return 'not-handled'
    },
    handlePastedText(text = '', _html = '', editorState) {
      if (limit > 0) {
        const textLengthAfterInsertion = countTextAfterInsertion(text, editorState)
        if (textLengthAfterInsertion > limit) {
          return 'handled'
        }
      } else if (0 === limit) {
        return 'handled'
      }
      return 'not-handled'
    },
    onChange(editorState) {
      if (limit > 0) {
        const content = editorState.getCurrentContent()
        const text = content.getPlainText('\n')
        const textLength = countText(trim ? text.trim() : text)
        if (textLength > limit) {
          const blockMap = content.getBlockMap()
          const lastBlock = blockMap.last()
          const focusKey = lastBlock.getKey()
          const focusOffset = lastBlock.getLength()
          const anchorKey = focusKey
          const anchorOffset = Math.max(0, focusOffset - (textLength - limit)) //TODO: count several blocks
          const selection = SelectionState.createEmpty(anchorKey).merge({
            anchorKey,
            anchorOffset,
            focusKey,
            focusOffset,
            isBackward: false
          })
          const editorStateSelection = editorState.getSelection()
          return (editorStateSelection.getHasFocus() ? EditorState.moveFocusToEnd : EditorState.moveSelectionToEnd)(
            EditorState.push(editorState, Modifier.removeRange(content, selection, 'forward'), 'trim-over-limit')
          )
        }
      } else if (0 === limit) {
        return EditorState.createEmpty()
      }
      return editorState
    }
  }
}
